import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import _ from 'lodash';

import { ArrowBack, ArrowForward } from '@mui/icons-material';

import { IconButton } from '@mui/material';

import moment from 'moment';

import Link from 'next/link';

import { useRouter } from 'next/router';

import { WordPressImageTransformer } from '../../../utils/wordpress-image-transformer';

import useResponsive from '../../../utils/responsive';

import { eventService } from '../../services/homii-services';

import Carousel from '../carousel/carousel.component';


const DesktopBlogCarousel = (props) => {

    const { isMobile, isTablet } = useResponsive();
    const { data, title, showAll } = props;
    const [blogPostCount, setBlogPostCount] = useState(0);
    const [relatedTags, setRelatedTags] = useState([]);
    const [blogData, setBlogData] = useState([]);

    const router = useRouter();
    const currentSlug = _.get(router, 'query.slug');

    const nextButtonRight = 11;
    const backButtonRight = 14;

    let leftGridSize = 2;
    let rightGridSize = 10;
    let marginTop = 110;

    if (isTablet) {
        leftGridSize = false;
        rightGridSize = 12;
        marginTop = 20;
    }

    useEffect(() => {
        _.forEach(data, (post) => {
            if (_.get(post, 'acf.url_slug') === currentSlug) {
                setRelatedTags(_.get(post, 'acf.meta_data_tags'));
            }
        });
    }, []);

    useEffect(() => {
        const blogPosts = [];
        if (showAll) {
            data.filter(
                (x) =>
                    x.acf.meta_data_categories !== false &&
                    x.acf.meta_data_categories.map((_) => _.category === 'Blog'),
            ).map((_) => blogPosts.push(_));
        } else {
            const _relatedTags = relatedTags.map((_) => _.tag);
            const _blogs = data.filter(
                (x) =>
                    x.acf.meta_data_categories !== false &&
                    x.acf.meta_data_categories.map((_) => _.category === 'Blog') &&
                    x.acf.url_slug !== currentSlug &&
                    x.acf.meta_data_tags !== false,
            );

            _.forEach(_blogs, (_blog) => {
                const _blogTags = _blog.acf.meta_data_tags.map((_) => _.tag);
                _.forEach(_blogTags, (_tag) => {
                    if (_relatedTags.includes(_tag)) {
                        blogPosts.push(_blog);
                    }
                });
            });
        }

        setBlogData(blogPosts);
        setBlogPostCount(_.size(blogPosts));
    }, [relatedTags]);

    const responsive = {
        desktop: {
            breakpoint: { 
                max: 3000, 
                min: 1024 
            },
            items: 4,
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0
            },
            items: 1,
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 464
            },
            items: 2,
        }
    };    

    const checkCategory = (categories) => {
        let isBlog = false;
        if (!categories) {
            return isBlog;
        }
        _.forEach(categories, (category) => {
            if (category.category === 'Blog') {
                isBlog = true;
            }
        });
        return isBlog;
    };

    const onPostClicked = (slug) => {
        eventService.logCustomEvent('viewed-blog-post', {
            description: `User viewed ${slug} and was directed from home page`,
            slug,
        });
    };

    const onBlogPostClick = (blogPostSlug) => {
        eventService.logCustomEvent('viewed-blog-post', {
            description: `User viewed ${blogPostSlug} and was directed from blog page`,
            slug: blogPostSlug,
        });
        router.push(`/blog/posts/${blogPostSlug}`);
    };    

    const checkForTags = (tags) => {
        return _.map(tags, (tag, index) => {
            const type = _.toUpper(_.get(tag, 'tag'));
            return <span key={index}>{type}</span>;
        });
    };

    const renderCarouselItem = () => {

        const sortedPostByDate = blogData.sort(
            (a, b) => b.meta_data_publish_date - a.meta_data_publish_date,
        );

        return _.map(sortedPostByDate, (item, index) => {

            const blogTitle = _.get(item, 'acf.seo_title');
            const slug = _.get(item, 'acf.url_slug');
            const tags = _.get(item, 'acf.meta_data_tags');
            const featuredImagePre = _.get(item, 'acf.featured_image');
            const featuredImage = WordPressImageTransformer(featuredImagePre, 500, 100);
            const featuredImageAlt = _.get(item, 'acf.featured_image_alt');
            const postPublished = _.get(item, 'acf.meta_data_publish_date');
            const categories = _.get(item, 'acf.meta_data_categories');

            const isBlog = checkCategory(categories);

            if (!isBlog || slug === currentSlug) {
                return null;
            }

            return (               

                <div index={index} key={index} className="desktop-carousel-inner">

                    <div href={`/blog/posts/${slug}`} as={`/blog/posts/${slug}`} onClick={() => onBlogPostClick(slug)}>

                        <a className='desktop-blog-carousel-styled-anchor-tag' target="_blank">

                            <div className='desktop-blog-carousel-image-container'>

                                <img
                                    src={featuredImage}
                                    alt={featuredImageAlt || 'blog-article'}
                                    width={462}
                                    height={427}
                                    id={`${slug}-carousel-button`}
                                    onClick={() => onPostClicked(slug)}
                                />

                            </div>

                        </a>

                    </div>

                    <div className='desktop-blog-carousel-caption-container '>

                        <span>

                            <span className='desktop-blog-carousel-caption'>{checkForTags(tags)}</span>

                        </span>

                        <span className='desktop-blog-carousel-published-date'>

                            {_.upperCase(moment(postPublished).format('DD MMMM YYYY'))}

                        </span>

                    </div>

                    <h4 className="desktop-blog-carousel-title-paragraph selected-blog">{blogTitle}</h4>

                </div>

            );
        });
    };

    const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
        return (
            <div id="desktop-blog-carousel-button-container" className="desktop-blog-carousel-button-container">
                <IconButton
                    className="desktop-blog-carousel-back-button" onClick={() => previous()}
                    aria-label="Back"                 
                >
                    <ArrowBack className="desktop-blog-carousel-arrow-icon" />
                </IconButton>

                <IconButton
                    className="desktop-blog-carousel-next-button" onClick={() => next()}
                    aria-label="Next"
                >
                    <ArrowForward className="desktop-blog-carousel-arrow-icon" />
                </IconButton>
            </div>
        );
    };

    const renderCarousel = () => {

        if (isMobile) {
            return null;
        }

        return (

            <div className='main-grid-container'>

                <div className='main-grid-item main-grid-xs-2'>

                    <div className='desktop-blog-carousel-header-container'>

                        <div>

                            <h4 className='desktop-blog-carousel-header4'>
                                {title || 'Featured Articles'}
                            </h4>                           

                            <a href="/blog" className='desktop-blog-carousel-anchor-tag' id="blog_link">Read all</a>                           

                        </div>

                    </div>

                </div>

                <div id='desktop-carousel' className='main-grid-item main-grid-xs-10'>

                    <div className='desktop-blog-carousel-carousel-container'>

                        <Carousel
                            responsive={responsive}
                            showDots={false}
                            arrows={false}
                            slidesToSlide={1}                            
                            draggable={false}                           
                            customCarouselItemWidth={654.719}
                            renderButtonGroupOutside={true}
                            customButtonGroup={<ButtonGroup />}>
                                {renderCarouselItem()}
                        </Carousel>

                    </div>

                </div>

            </div>

        );
    };

    return renderCarousel();
};

export default DesktopBlogCarousel;

DesktopBlogCarousel.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    showAll: PropTypes.bool,
};
